/**
 * Universal Line Height Calculator
 * Calculates the height of line elements based on boxes for multiple section types
 */

// Configuration for different section types
const LINE_HEIGHT_CONFIG = {
    textImgDecor: {
        containerSelector: '.textImgDecor-container__items',
        lineSelector: '.textImgDecor-container__items--line',
        boxSelector: '.textImgDecor-container__items .box',
        imageSelector: '.box-container__image .wrapper'
    },
    process: {
        containerSelector: '.process-container__items',
        lineSelector: '.process-container__items--line',
        boxSelector: '.process-container__items .box',
        imageSelector: '.box-container__image .wrapper'
    }
    // Dodaj tutaj kolejne konfiguracje dla innych sekcji:
    // przykład: {
    //     containerSelector: '.przykład-container__items',
    //     lineSelector: '.przykład-container__items--line',
    //     boxSelector: '.przykład-container__items .box',
    //     imageSelector: '.box-container__image .wrapper'
    // }
};

document.addEventListener('DOMContentLoaded', function() {
    calculateAllLineHeights();
    
    // Recalculate on window resize
    window.addEventListener('resize', debounce(calculateAllLineHeights, 250));
});

function calculateAllLineHeights() {
    // Iteruj przez wszystkie konfiguracje i oblicz wysokości linii
    Object.keys(LINE_HEIGHT_CONFIG).forEach(sectionType => {
        calculateLineHeightForSection(sectionType, LINE_HEIGHT_CONFIG[sectionType]);
    });
}

function calculateLineHeightForSection(sectionType, config) {
    const containers = document.querySelectorAll(config.containerSelector);
    
    containers.forEach(container => {
        const line = container.querySelector(config.lineSelector);
        const boxes = container.querySelectorAll(config.boxSelector);
        
        if (!line || boxes.length === 0) {
            return;
        }
        
        let totalHeight = 0;
        
        boxes.forEach((box, index) => {
            const boxHeight = box.offsetHeight; // Y
            const imageElement = box.querySelector(config.imageSelector);
            const imageHeight = imageElement ? imageElement.offsetHeight : 0; // XY
            
            if (index === 0) {
                // Pierwszy box: wysokość Y - 1/2 wysokości XY
                totalHeight += boxHeight - (imageHeight / 2);
            } else if (index === boxes.length - 1) {
                // Ostatni box: 1/2 wysokości XY
                totalHeight += imageHeight / 2;
            } else {
                // Środkowe boxy: pełna wysokość Y
                totalHeight += boxHeight;
            }
        });
        
        // Ustaw wysokość linii
        line.style.height = totalHeight + 'px';
        
        console.log(`[${sectionType}] Calculated line height: ${totalHeight}px for container with ${boxes.length} boxes`);
    });
}

// Debounce function to limit resize events
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
